<template>
  <div>

    <Toolbar :handle-submit="onSendFileForm" :handle-reset="resetForm">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-alert-decagram</v-icon>{{$t('orderaction.orderaction')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <ActionForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import ActionForm from '../../components/orderaction/Form';
import Loading from '../../components/Loading';
import CreateMixin from '../../mixins/CreateMixin';
import FileMixin from '../../mixins/FileMixin';
import Toolbar from '../../components/Toolbar';
import NotificationMixin from '../../mixins/NotificationMixin';

const servicePrefix = 'OrderAction';

const { mapFields } = createHelpers({
  getterType: 'orderaction/getField',
  mutationType: 'orderaction/updateField'
});

export default {
  name: 'OrderActionCreate',
  servicePrefix,
  mixins: [CreateMixin,FileMixin,NotificationMixin],
  components: {
    Loading,
    ActionForm,
    Toolbar
  },
  data() {
    return {
      item: {
        orderRef: this.$route.params.parent,
      },
      defaultvalues: {

      }
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'uploaded','created', 'violations']),

  },
  methods: {
    ...mapActions('orderaction', ['create','upload', 'reset']),
    onSendFileForm() {
      if(this.item.orderRef) {
        this.onSendForm()
        this.inputfile = this.item.file;
      } else {
        this.showError(this.$t('order.erroractionnoorder'));
      }

    },
    onCreated(item) {
      this.showMessage(`${item['titre']} ${this.$t('global.created')}`);

      this.$router.push({
        name: `OrderShow`,
        params: { id: item['orderRef']['@id'] }
      });

    },
  }

};
</script>
